import { InsuranceRankedColumns } from "./InsuranceRankedColumns";
import { ThemeContext } from "./ThemeContext";

export const RentersInsuranceCompany = (props) => (
	<ThemeContext.Provider value={{ hasTrustpilotWidget: false }}>
		<InsuranceRankedColumns {...props} />
	</ThemeContext.Provider>
);
